<template>
  <div class="dialog-wrapper">
    <el-dialog
      title="添加培训班招标计划"
      :visible.sync="isOpen"
      width="480px"
      top="20vh"
      :close-on-click-modal="false"
      :before-close="dialogBeforeClose"
    >
      <div class="dialog-wrapper">
        <div class="form-item pt0">
          <div class="label">类型</div>
          <div class="form-item-content">
            <el-select
              v-model="createForm.classTrainType"
              class="w360"
              disabled
              placeholder="请选择培训班类型"
            >
              <el-option
                v-for="item in class_train_type_list"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="form-item">
          <div class="label">级别</div>
          <div class="form-item-content">
            <el-radio-group v-model="createForm.classLevel" class="radio-content">
              <el-radio
                v-for="item in levelOptions"
                :label="item.value"
                :key="item.value"
                class="radio-item"
                border
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogAction(true)"
          >确 定</el-button>
        <el-button type="danger" @click="handleDialogAction(false)">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  class_train_type_list,
  createHeighClassLevelList,
  HidgClassStatus,
} from "@/assets/js/select";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      class_train_type_list, // 培训班类型
      createForm: {
        classTrainType: "train",
        classLevel: "",
      },
    };
  },

  computed: {
    levelOptions() {
      const { classTrainType } = this.createForm;
      if (!classTrainType) {
        this.createForm.classTrainType = "continue_education";
        let defaultList = createHeighClassLevelList.filter((item) => {
          return item.typeList.includes(classTrainType);
        });
        this.createForm.classLevel = defaultList[0].value;
        return defaultList;
      } else {
        let defaultList = createHeighClassLevelList.filter((item) => {
          return item.typeList.includes(classTrainType);
        });
        this.createForm.classLevel = defaultList[0].value;
        return defaultList;
      }
    },
  },

  methods: {
    dialogBeforeClose() {
      this.$emit("update:isOpen", false)
    },

    handleDialogAction(actionStatus) {
      const {  classTrainType, classLevel } = this.createForm;
      if(classTrainType && classLevel ) {
        this.$emit('callback', true, actionStatus, this.createForm); // p1： 操作结果状态（成功， 失败）， p2: 操作状态（确认，取消）
      } else {
        console.warn('缺少表单信息【错误冗余】')
        this.$emit('callback', false, actionStatus, this.createForm); // p1： 操作结果状态（成功， 失败）， p2: 操作状态（确认，取消）
      }
    },

    
  },
};
</script>

<style lang="stylus" scoped>
.title
  font-size: 18px

.form-item
  padding  10px 0
  display: flex
  justify-content: flex-start
  .label
    width 80px
    height: 40px
    line-height: 40px
    text-align: right
    padding-right: 15px
  .form-item-content
    flex 1

.dialog-footer
  width: 40%
  margin: 0 auto
  display: flex
  justify-content: space-around

.pt0 
  padding-top 0px
  
</style>